import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import Text from '../text';
import Colors from '../colors';
import Spacer from '../spacer';
import SvgRenderer from '../svg-renderer';
import Container from './container';
const SvgContainer = styled.View`
  align-items: center;
  justify-content: center;
  height: 93px;
  width: ${props => props.centered ? '100%' : '93px'};
`;
export default function ErrorScreen(props) {
  return /*#__PURE__*/React.createElement(Container, {
    paddingBottom: props.paddingBottom,
    backgroundColor: props.backgroundColor
  }, /*#__PURE__*/React.createElement(SvgContainer, {
    centered: props.centered
  }, /*#__PURE__*/React.createElement(SvgRenderer, {
    source: props.illustration,
    height: 93,
    width: 93
  })), /*#__PURE__*/React.createElement(Spacer, {
    size: "d32",
    height: true
  }), /*#__PURE__*/React.createElement(Text.H4, {
    color: props.titleColor,
    align: props.centered ? 'center' : 'left'
  }, props.title), props.label !== '' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    size: "f12"
  }), /*#__PURE__*/React.createElement(Text.BodyLarge, {
    color: props.labelColor,
    align: props.centered ? 'center' : 'left'
  }, props.label)), /*#__PURE__*/React.createElement(Spacer, {
    size: "d32",
    height: true
  }), props.children);
}
ErrorScreen.defaultProps = {
  paddingBottom: 0,
  label: '',
  centered: false,
  titleColor: Colors.gray600,
  labelColor: Colors.gray100,
  backgroundColor: Colors.white
};
ErrorScreen.propTypes = {
  children: PropTypes.node.isRequired,
  illustration: PropTypes.string.isRequired,
  label: PropTypes.string,
  paddingBottom: PropTypes.number,
  title: PropTypes.string.isRequired,
  centered: PropTypes.bool,
  titleColor: PropTypes.node,
  labelColor: PropTypes.node,
  backgroundColor: PropTypes.node
};
//# sourceMappingURL=error-screen.js.map